import { render, staticRenderFns } from "./BlogPostBadge.vue?vue&type=template&id=2d95440c&scoped=true&"
import script from "./BlogPostBadge.vue?vue&type=script&lang=js&"
export * from "./BlogPostBadge.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostBadge.vue?vue&type=style&index=0&id=2d95440c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95440c",
  null
  
)

export default component.exports